import { Redirect } from 'react-router';
import { providerChartsReviewRoute, providerSuperviseeChartsReviewForMatchRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useCollaboratePhysicianMatchQuery, useCollaborativeChartsReviewForMatchQuery } from '@uplift/queries';
import { ProviderLayout } from '@uplift/ui-v2';


const SuperviseeChartsReviewProxyPageContent = () => {
  const { collaborativeMatchId } = providerSuperviseeChartsReviewForMatchRoute.useParams();
  const { data: collaborativeMatch } = useCollaboratePhysicianMatchQuery(collaborativeMatchId);
  const { data: chartsReview } = useCollaborativeChartsReviewForMatchQuery(collaborativeMatchId);

  if (!collaborativeMatch) {
    return <Redirect to={ROUTING_CONFIG.collaborationManage} />;
  }

  if (!chartsReview) {
    return <Redirect to={ROUTING_CONFIG.collaborationManage} />;
  }

  return <Redirect to={providerChartsReviewRoute.createLink({ reviewId: chartsReview.id })} />;
};


export const SuperviseeChartsReviewProxyPage: React.VFC = () => {
  return (
    <ProviderLayout>
      <SuperviseeChartsReviewProxyPageContent />
    </ProviderLayout>
  );
};
